module.exports = __webpack_public_path__ + "img/gadgets_settings_pressed@3x.9538625e.png";